import { z } from 'zod';

const roleSchema = z.object({
  id: z.string().optional(),
  name: z.string().optional(),
  type: z.string().optional(),
  departmentId: z.string().optional(),
  departmentName: z.string().optional(),
});

const branchSchema = z.object({
  branchId: z.string(),
  branchName: z.string(),
  groupName: z.string().nullish(),
});

export const adminUserSchema = z.object({
  authType: z.literal('user'),
  id: z.string(),
  email: z.email(),
  username: z.string().nullish(),
  firstName: z.string().nullish(),
  lastName: z.string().nullish(),
  phone: z.string().nullish(),
  avatar: z.string().nullish(),
  roles: z.array(roleSchema),
  permissions: z.array(z.string()),
  branches: z.array(branchSchema),
});

export type AdminUser = z.infer<typeof adminUserSchema>;

export const sessionResponseSchema = z.object({
  user: adminUserSchema,
});

export function getDisplayName(user: AdminUser): string {
  const fullName = [user.firstName, user.lastName].filter(Boolean).join(' ');
  return fullName || user.email;
}

export function hasRole(user: AdminUser, role: string): boolean {
  return user.roles.some((candidate) => candidate.type === role);
}

export function hasPermission(
  user: AdminUser,
  resource: string,
  action = 'READ',
): boolean {
  if (hasRole(user, 'SUPER_ADMIN')) return true;
  const normalizedAction = action.toUpperCase();
  return (
    user.permissions.includes(`${normalizedAction}:${resource}`) ||
    user.permissions.includes(`MANAGE:${resource}`)
  );
}
